import React from "react";
import { connect } from "react-redux";
import { getters } from "../model";
import { Div } from "components/Base";

const decorate = connect(state => ({
  isSessionForm: getters.isSessionForm(state),
  sessionTitle: getters.sessionTitle(state)
}));

const EditingSession = ({ sessionTitle, isSessionForm }) => {
  return isSessionForm ? (
    <Div bg="gray1" bra={2} p={3} mb={3} display="row.center.center">
      You are editing the session: {sessionTitle}
    </Div>
  ) : null;
};

export default decorate(EditingSession);
